import {
    memo,
    type PropsWithChildren
} from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Resource } from "ui/support/Resource";
import When from "ui/support/When";
import ActionPanel from "ui/molecules/ActionPanel";
import type { TabLayoutProps } from "./types";

const TabLayout = ({
    sx,
    title,
    auxSlot,
    isLoading,
    isEmpty,
    emptySlot,
    isError,
    errorSlot,
    children,
    ActionPanelProps
}: PropsWithChildren<TabLayoutProps>) => (
    <Box
        sx={
            {
                marginRight: 2,
                marginLeft: 2,
                ...sx
            }}
    >
        <When
            if={Boolean(title || auxSlot)}
            then={() => (
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        mb: title ? 2 : 0,
                        gap: 3
                    }}
                >
                    {title && (
                        <Typography
                            variant='h6'
                        >
                            {title}
                        </Typography>
                    )}
                    {auxSlot}
                </Box>
            )}
        />
        <Resource
            isError={isError}
            errorSlot={errorSlot}
            isEmpty={isEmpty}
            emptySlot={emptySlot}
            isLoading={isLoading}
        >
            {children}
        </Resource>
        {ActionPanelProps && (
            <ActionPanel
                {...ActionPanelProps}
            />
        )}
    </Box>
);

export default memo(TabLayout);
